import { useCacheLocal } from "@/hooks/useCacheLocal";
import { TApiSortsReq } from "@/types/api";
import { createContext, ReactNode, useContext, useState } from "react";

type TRsoFilterCache = {
  page?: number | null;
  tab?: string | null;
  sorts?: TApiSortsReq[];
  keyword?: string | null;
};

type RsoFilterCacheContextType = {
  rsoFilterCache: TRsoFilterCache;
  setRsoFilterCache: (newFilter: TRsoFilterCache) => void;
};

const RsoFilterCacheContext = createContext<RsoFilterCacheContextType | undefined>(undefined);

export const RsoFilterCacheProvider = ({ children }: { children: ReactNode }) => {
  const { getJSON, setJSON } = useCacheLocal("rso-filter");

  const [rsoFilterCache, setRsoFilter] = useState<TRsoFilterCache>({
    ...getJSON(),
  });

  const setRsoFilterCache = (newFilter: TRsoFilterCache) => {
    setJSON(newFilter);
    setRsoFilter(newFilter);
  };

  return <RsoFilterCacheContext.Provider value={{ rsoFilterCache, setRsoFilterCache }}>{children}</RsoFilterCacheContext.Provider>;
};

export const useRsoFilterCache = (): RsoFilterCacheContextType => {
  const context = useContext(RsoFilterCacheContext);
  if (!context) {
    throw new Error("useRsoFilter must be used within RsoFilterProvider");
  }
  return context;
};
